import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { VouchersContent } from '@starjack/widgets/vouchers';
import { Permission } from '@/models/user';

import { PageWithLayout } from '@/models/page';

const Vouchers: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Gutscheine | Starjack Admin</title>
            </Helmet>

            <VouchersContent />
        </>
    );
};

Vouchers.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

Vouchers.isProtected = true;

Vouchers.permissions = [Permission.TICKETS_NAV, Permission.TICKETS_CANCEL];

export default Vouchers;
